import React from "react"
import { useTranslation } from "react-i18next"

import { ARCHITECT_NAME_MAX_LENGTH } from "../../containers/Lead/constants/lead-source-architect.ts"
import { LeadOverviewField } from "../../containers/Lead/LeadWorkspacePage/overview/LeadOverviewField.tsx"
import { TextInput } from "../Input/TextInput.tsx"

interface ArchitectNameFieldProps {
  disabled?: boolean
  value: string | null | undefined
  onChange: (value: string | null) => void
}

// Shown next to Source, in the Lead and Project workspace cards alike,
// whenever that source is Architect / Designer — kept in one place so the
// two surfaces can't drift on label, placeholder, length limit, or how a
// cleared field is normalized.
function ArchitectNameField({
  disabled,
  value,
  onChange
}: ArchitectNameFieldProps) {
  const { t } = useTranslation()

  return (
    <LeadOverviewField label={t("leadWizard.project.architectName")}>
      <TextInput
        disabled={disabled}
        aria-label={t("leadWizard.project.architectName")}
        maxLength={ARCHITECT_NAME_MAX_LENGTH}
        placeholder={t("leadWizard.project.architectNamePlaceholder")}
        value={value ?? undefined}
        onChange={(event) => onChange(event.target.value || null)}
      />
    </LeadOverviewField>
  )
}

export { ArchitectNameField }
